import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { GeneralService } from '../../../services/general/general.service';
import { Categoria } from '../../../../model/class/Categoria';
import { NoTildePipe } from '../../../pipes/no-tilde.pipe';
import { DragulaService } from 'ng2-dragula';
import { ToastsManager } from 'ng2-toastr';
import * as _ from 'lodash';

@Component({
  selector: 'app-categorias-especiales',
  templateUrl: './categorias-especiales.component.html',
  styleUrls: ['./categorias-especiales.component.css'],
  providers: [DragulaService]
})
export class CategoriasEspecialesComponent implements OnInit {

  loader = {
    editar: false
  };

  private todasCategorias: Categoria[] = [];
  public catMostradas: Categoria[] = [];

  public options = {
    orden: 'orden',
    estado: 'todas',
    textoBuscado: ''
  };

  constructor(
    private _generalService: GeneralService,
    private categoriaService: CategoriaService,
    private noTildePipe: NoTildePipe,
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
  ) {
    this.dragulaService.drag.subscribe(
      (value) => {
        value[1].classList.add('td-dragable');
      }
    );

    this.dragulaService.out.subscribe((value) => {
      value[1].classList.remove('td-dragable');
      this.emparejarOrden();
    });
  }

  ngOnInit() {

    this.categoriaService.getTodasDeFantasia()
      .subscribe(
        (resp) => {
          for (const cat of resp.data) {
            this.todasCategorias.push(new Categoria(cat));
          }

          this.catMostradas = _.clone(this.todasCategorias);
          this.ordenar();
        }
      );
  }

  emparejarOrden() {
    this.catMostradas.forEach((element, key) => {
      element.ordenFantasia = key;
    });
  }

  saveOrder() {
    this.loader.editar = true;
    const data: any[] = [];

    for (const icat of this.catMostradas) {
      data.push({
        id: icat.id,
        orderFantasy: icat.ordenFantasia
      });
    }

    this.categoriaService.changeOrderFantasyCategories(data)
      .subscribe(
        (resp) => {
          this.loader.editar = false;
          this.toasts.success('Orden de las categorias especiales cambiado exitosamente.');
          this._generalService.revalidarCache('selection').subscribe();
        },
        (error) => {
          this.loader.editar = false;
          this.toasts.error('Error al cambiar el orden.');
        }
      );
  }

  buscar() {
    const filtrados: Categoria[] = [];
    this.filtrarEstado();

    for (const cat of this.catMostradas) {

      let nombre = cat.nombre.toLowerCase();
      nombre = this.noTildePipe.transform(nombre);

      let texto = this.options.textoBuscado.toLowerCase();
      texto = this.noTildePipe.transform(texto);

      if (nombre.indexOf(texto) >= 0) {
        filtrados.push(cat);
      }
    }

    this.catMostradas = filtrados;
    this.ordenar();
  }

  limpiarBusqueda() {
    this.options.textoBuscado = '';
    this.filtrarEstado();
    this.ordenar();
  }

  filtrarEstado() {
    if (this.options.estado === 'todas') {
      this.catMostradas = _.clone(this.todasCategorias);
    } else if (this.options.estado === 'publicadas') {
      this.catMostradas = _.filter(this.todasCategorias, { 'publicada': 1 });
    } else if (this.options.estado === 'noPublicadas') {
      this.catMostradas = _.filter(this.todasCategorias, { 'publicada': 0 });
    }
  }

  ordenar() {
    switch (this.options.orden) {
      case 'reciente':
        this.catMostradas = _.orderBy(this.catMostradas, 'fecCreacion', 'desc');
        break;
      case 'antigua':
        this.catMostradas = _.orderBy(this.catMostradas, 'fecCreacion', 'asc');
        break;
      case 'orden':
        this.catMostradas = _.orderBy(this.catMostradas, 'ordenFantasia', 'asc');
        break;
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/categorias-especiales/categorias-especiales.component.ts